import {isRequestError, RequestError} from "../../Model/RequestError";
import {joinUrl} from "../../Utilities/UriUtilities";
import {authenticationHeader, executeWithErrorResponseHandling, jsonContentTypeHeader} from "../ApiUtilities";
import axios from "axios";
import {COUNTER_API_CALLS} from "../../Service/CounterMetricsProvider";
import {Reseller} from "../../Types/Reseller";

/**
 * Function to download the agreement preview PDF document for the plan configured in the payload
 */
export const downloadPlanAgreementPreview = async (
  apiDomain: string,
  payload: any,
  reseller: Reseller,
): Promise<RequestError | void> => {
  const endpoint = joinUrl(apiDomain, `${reseller}/plan/agreement/preview`)
  const headers = {...{"Accept": "application/pdf"},
    ...jsonContentTypeHeader()}
  const response = await executeWithErrorResponseHandling<{}>(() =>
    axios.post(endpoint, payload, {
      headers: headers,
      responseType: 'blob'
    }))
  if (isRequestError(response)) {
      COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/subscriber/plan/agreement/preview", "status": "error"}})
      return response
  } else if (response?.data) {
      COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/subscriber/plan/agreement/preview", "status": "success"}})

      const data = response.data as Blob;
      const link = window.URL.createObjectURL(data);
      const a = document.createElement('a');
      const fileName = `${payload["packageDescription"]}-plan-information.pdf`;
      a.href = link;
      a.download = fileName;
      a.click();
  }
}